import React, { RefObject, forwardRef } from 'react'
import { DateRange } from 'react-day-picker'

import {
  CalendarTypes,
  CloseButton,
  Calendar,
} from '../../../../../core/components'

import { SectionHeader } from '../SectionHeader/SectionHeader'

import './Dates.css'

type Props = {
  ref: RefObject<HTMLDivElement>
  onClose?: () => void
  autoFocus?: boolean
  calendarRange: DateRange | undefined
  setCalendarRange: (range: DateRange | undefined) => void
  disableCalendarDates?: CalendarTypes['disableCalendarDates']
  selectedPath?: string
  language?: string
}

export const Dates = forwardRef<HTMLDivElement, Props>(
  (
    {
      onClose,
      autoFocus,
      calendarRange,
      setCalendarRange,
      disableCalendarDates,
      selectedPath,
      language,
    },
    ref
  ) => {
    return (
      <div id="will-filter-bar-dates" ref={ref}>
        <SectionHeader
          title={''}
          action={onClose && <CloseButton handleClose={onClose} />}
        />

        <div className="will-dates-filter-container">
          <Calendar
            autoFocus={autoFocus}
            calendarRange={calendarRange}
            setCalendarRange={setCalendarRange}
            disableCalendarDates={disableCalendarDates}
            selectedPath={selectedPath}
            language={language}
          />
        </div>
      </div>
    )
  }
)

Dates.displayName = 'Dates'
